// ----------------------------------------------------------------------------
// Image Radio
// ----------------------------------------------------------------------------

var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var _ = require('lodash');

var CONTAINER     = '.image-radio';
var INPUT         = '.image-radio .radio-menu__element';
var INPUT_WRAPPER = '.radio-menu__option';

module.exports = function() {
    $(document).on('click', INPUT, _.bind(image_radio.change, image_radio));
    $(document).on('change', INPUT, _.bind(image_radio.change, image_radio));

    $(INPUT).each(function() {
        $(this).change();
    });
};

var image_radio = {
    change: function(e) {
        var $this             = $(e.target);
        var $all_wrappers     = $this.parents(CONTAINER).find(INPUT_WRAPPER);
        var $selected_wrapper = $all_wrappers.find('input:checked').parents(INPUT_WRAPPER);

        $all_wrappers.removeClass('selected');
        $selected_wrapper.addClass('selected');
    }
};
